module.exports = __webpack_public_path__ + "img/icon-refresh.2eaab89e.svg";